import { getOrderItemsByRewardId } from './get-order-items-by-reward-id';
export const getOrderItemCountByRewardId = (rewardId) => {
    return getOrderItemsByRewardId(rewardId).length;
};
